<template>
    <td-dialog
        :lockScroll="false"
        :title="$t(title)"
        :before-close="publicVerDialogClose"
        :visible.sync="publicVerDialogVisible"
        width="900px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-row>
            <el-col :span="24">
                <el-form :inline="true" :model="versionForm" ref="versionForm" :rules="versionFormRules">
                    <el-form-item :label="$t('pgCommon.PUBLIC_VERSION_INFO')" prop="description">
                        <td-input type="textarea" v-model="versionForm.description" width="758" :rows="4" maxlength="200"></td-input>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <div slot="footer">
            <td-button type="primary" @click="publicNewVersion" :loading="publicLoading">{{ $t('pgCommon.PUBLIC') }}</td-button>
            <td-button @click="publicVerDialogClose">{{ $t('extendCommon.CANCEL') }}</td-button>
        </div>
    </td-dialog>
</template>
<script>
import Api from './../assets/api.js';
export default {
    props: ['title', 'publicVerDialogVisible', 'row'],
    created() {},
    data() {
        return {
            versionForm: {
                description: ''
            },
            publicLoading: false,
            versionFormRules: {
                description: [{ required: true, message: this.$t('pgCommon.INPUT_CONTENT'), trigger: 'change' }]
            }
        };
    },
    methods: {
        publicNewVersion() {
            this.$confirm(this.$t('pgMessage.PUBLIC_TEMPLATE_TIPS'), this.$t('extendCommon.TIPS'), {
                confirmButtonText: window.vue.$t('extendCommon.CONFIRM'),
                cancelButtonText: window.vue.$t('extendCommon.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = {
                        templateKey: this.row.templateKey,
                        templateId: this.row.templateId,
                        modelId: this.row.modelId,
                        deploymentId: this.row.deploymentId,
                        description: this.versionForm.description
                    };
                    this.$refs.versionForm.validate(valid => {
                        if (valid) {
                            Api.publicNewVersion(JSON.stringify(param), response => {
                                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                                    return;
                                }
                                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                    this.$log.error('service/activateOldVersion', response.data.statusMessage);
                                    return;
                                }
                                this.$message({ showClose: true, message: this.$t('pgCommon.PUBLIC_SUCCESS'), type: 'success' });
                                this.$emit('callbackQuery');
                                this.$emit('btnQuery');
                                this.publicVerDialogClose();
                            });
                        }
                    });
                })
                .catch(() => {
                    // this.$message.info(this.$t('common.ADD_FAIL'))
                    // this.$log.error('extendInfo/btnDelete---- Fail')
                });
        },
        publicVerDialogClose: function() {
            this.$emit('publicVerDialogClose');
        }
    }
};
</script>
<style></style>
